import React from 'react';
import { useTranslation } from 'react-i18next';

interface LanguageSwitcherProps {
    className?: string;
    variant?: 'default' | 'compact';
}

export const LanguageSwitcher: React.FC<LanguageSwitcherProps> = ({
    className = '',
    variant = 'default'
}) => {
    const { i18n } = useTranslation();

    const changeLanguage = (lng: string) => {
        i18n.changeLanguage(lng);
        localStorage.setItem('language', lng);
    };

    const currentLanguage = i18n.language;

    if (variant === 'compact') {
        return (
            <div className={`flex items-center space-x-1 ${className}`}>
                <button
                    onClick={() => changeLanguage('ru')}
                    className={`px-2 py-1 rounded text-xs font-medium transition-colors ${currentLanguage === 'ru'
                            ? 'bg-blue-600 text-white'
                            : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
                        }`}
                >
                    RU
                </button>
                <button
                    onClick={() => changeLanguage('kk')}
                    className={`px-2 py-1 rounded text-xs font-medium transition-colors ${currentLanguage === 'kk'
                            ? 'bg-blue-600 text-white'
                            : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
                        }`}
                >
                    ҚАЗ
                </button>
            </div>
        );
    }

    return (
        <div className={`flex items-center space-x-2 ${className}`}>
            <button
                onClick={() => changeLanguage('ru')}
                className={`px-3 py-1.5 rounded-lg text-sm font-medium transition-all duration-200 ${currentLanguage === 'ru'
                        ? 'bg-gradient-to-r from-blue-500 to-blue-600 text-white shadow-md'
                        : 'bg-gray-100 text-gray-700 hover:bg-gray-200 hover:text-gray-900'
                    }`}
            >
                РУС
            </button>
            <button
                onClick={() => changeLanguage('kk')}
                className={`px-3 py-1.5 rounded-lg text-sm font-medium transition-all duration-200 ${currentLanguage === 'kk'
                        ? 'bg-gradient-to-r from-blue-500 to-blue-600 text-white shadow-md'
                        : 'bg-gray-100 text-gray-700 hover:bg-gray-200 hover:text-gray-900'
                    }`}
            >
                ҚАЗ
            </button>
        </div>
    );
};
